import EventCard from "./EventCard";
import { parse } from "date-fns";
import { eventVsVenue } from "../../../services/eventVsVenue";
import { Grid } from "@mui/material";

export const EventList = ({ events, venueData, safety = [], appList }) => {
  
  const parseDate = (date) => {
    try {
      if (date !== null && date !== undefined) {
        return parse(date, "yyyy-MM-dd", new Date());
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const parseTime = (time) => {
    try {
      if (time !== null && time !== undefined) {
        return parse(time, "HH:mm:ss", new Date());
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      return false;
    }
  };
  return (
    <div className="event_list">
      <Grid container spacing={3} >
        {events &&
          (events ?? [])?.map((event, idx) => {
            let eventVenue;
            let safetyCheck;
            let appId;
            let appArr = [];
            if (appList?.length > 1) {
              appArr = appList.toReversed();
            }
            else {
              appId = appList?.[0]?.app_id;
            }
            for (const item of safety) {
              if (item === event.id.toString()) {
                safetyCheck = true;
                if (item == appArr[idx]?.event_id) {
                  appId = appArr[idx].app_id;
                }
                
              }
            }
            let index = appArr?.find(info => info.event_id == event.id);
            if (index !== undefined) {
              
              appId = index.app_id;
            }
            for (const venue of venueData ?? []) {
              if (event?.venue?.[0] === venue.id) {
                eventVenue = venue;
              }
            }
            return (
              <Grid item xs={12} sm={4} key={idx}>
                <EventCard
                  key={idx}
                  appId={appId}
                  eventImage={eventVsVenue(event?.img_url, eventVenue?.img_url)}
                  eventName={event?.name}
                  eventStart={
                    event?.start_date !== undefined
                      ? parseDate(event?.start_date)
                      : new Date(event?.start)
                  }
                  eventEnd={
                    event.end_date !== undefined
                      ? parseDate(event?.end_date)
                      : new Date(event?.end)
                  }
                  eventHours={event.hours}
                  eventHoursStart={parseTime(
                    eventVsVenue(event?.start_hours, eventVenue?.start_hours),
                  )}
                  eventHoursEnd={parseTime(
                    eventVsVenue(event?.end_hours, eventVenue?.end_hours),
                  )}
                  eventStreet1={eventVenue?.street1}
                  eventCity={eventVenue?.city}
                  eventState={eventVenue?.state}
                  eventUrl={event?.id}
                  legacy={event?.legacy === true ? "/legacy" : ""}
                  legacyEvent={event.legacy}
                  safetyCheck={safetyCheck}
                  facebookUrl={event?.facebook_link}
                  eventId={event?.id}
                  eventStatus={event?.open_status === "open soon"}
                  hasVaryingTimes={event?.has_varying_times}
                />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default EventList;
